import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Modal, Progress } from "semantic-ui-react";
import { closeModal } from "../actions";

const ProgressModal = props => {
  const dispatch = useDispatch();

  const { progress, name, title } = props;

  const [percent, setPercent] = useState(0);

  useEffect(() => {
    setPercent(progress);
  }, [progress]);

  return (
    <Modal
      closeIcon="close"
      open={true}
      onClose={() => {
        dispatch(closeModal());
      }}
      {...props}
    >
      <Modal.Header>{title}</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          {name && <h3>{name}</h3>}
          <Progress percent={percent} size="small" autoSuccess />
        </Modal.Description>
      </Modal.Content>
    </Modal>
  );
};

export default ProgressModal;
